import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { isEmpty } from 'lodash';

export interface PageValidationSliceState {
    data: AnyObject;
}

export const initialState: PageValidationSliceState = {
    data: {},
};

export const pageValidationSlice = createSlice({
    name: 'pageValidation',
    initialState,
    reducers: (create) => ({
        setPageValidation: create.reducer((state, { payload }: PayloadAction<AnyObject>) => {
            state.data = payload;
        }),
        changePageValidation: create.reducer((state, { payload }: PayloadAction<AnyObject>) => {
            if (!isEmpty(state.data)) {
                state.data = { ...state.data, ...payload };
            }
        }),
        addPageValidationScenarioFields: create.reducer((state, { payload }: PayloadAction<AnyObject>) => {
            state.data = { ...state.data, ...payload };
        }),
        removePageValidationScenarioFields: create.reducer((state, { payload }: PayloadAction<string[]>) => {
            state.data = Object.keys(state.data).reduce((acc, key) => {
                if (!payload.includes(key)) {
                    acc[key] = state.data[key];
                }
                return acc;
            }, {});
        }),
        clearPageValidation: create.reducer((state) => {
            state.data = {};
        }),
    }),
    selectors: {
        selectPageValidation: (pageValidation) => pageValidation.data,
    },
});

export const {
    setPageValidation,
    changePageValidation,
    addPageValidationScenarioFields,
    removePageValidationScenarioFields,
    clearPageValidation,
} = pageValidationSlice.actions;
export const { selectPageValidation } = pageValidationSlice.selectors;
